"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _dangerouslyUpdateParcelData = _interopRequireDefault(require("../parcelData/dangerouslyUpdateParcelData"));

var _map = _interopRequireDefault(require("../parcelData/map"));

var _setMeta = _interopRequireDefault(require("../parcelData/setMeta"));

var _update = _interopRequireDefault(require("../parcelData/update"));

var _composeWith = _interopRequireDefault(require("unmutable/composeWith"));

var _map2 = _interopRequireDefault(require("unmutable/map"));

var _pipeWith = _interopRequireDefault(require("unmutable/pipeWith"));

var _toArray = _interopRequireDefault(require("unmutable/toArray"));

var _default = function _default(validatorMap) {
  return (0, _dangerouslyUpdateParcelData.default)(function (parcelData) {
    var invalidList = [];
    var topLevelValue = parcelData.value;
    var meta = parcelData.meta || {};
    var showInvalid = !!meta.showInvalid;

    if (meta._submit) {
      showInvalid = true;
    }

    var mapValidationRuleApplier = function mapValidationRuleApplier(validator, path) {
      var keyPath = path.split(".");
      return _composeWith.default.apply(void 0, (0, _toConsumableArray2.default)(keyPath.map(function (key) {
        return key === "*" ? function (next) {
          return (0, _map.default)(next);
        } : function (next) {
          return (0, _update.default)(key, next);
        };
      })).concat([function (parcelData) {
        var invalid = [].concat(validator).reduce(function (invalid, validator) {
          return invalid || validator(parcelData.value, {
            keyPath: keyPath,
            topLevelValue: topLevelValue
          });
        }, "");

        if (invalid && showInvalid) {
          invalidList.push(invalid);
        } else {
          invalid = undefined;
        }

        return (0, _setMeta.default)({
          invalid: invalid
        })(parcelData);
      }]));
    };

    var updateMeta = function updateMeta(parcelData) {
      var valid = invalidList.length === 0;
      var newMeta = {
        showInvalid: showInvalid,
        invalidList: invalidList,
        valid: valid,
        // _submit is meta that useParcelBuffer uses to trigger a submit
        // set this to false if a submit should not occur
        _submit: meta._submit && valid
      };
      return (0, _setMeta.default)(newMeta)(parcelData);
    };

    return _pipeWith.default.apply(void 0, [parcelData].concat((0, _toConsumableArray2.default)((0, _pipeWith.default)(validatorMap, (0, _map2.default)(mapValidationRuleApplier), (0, _toArray.default)())), [updateMeta]));
  });
};

exports.default = _default;